import React from 'react';
import {
  OptimizelyExperiment as OExperiment,
  OptimizelyFeature as OFeature,
} from '@optimizely/react-sdk';

import { ChildrenRenderFunction } from '@optimizely/react-sdk/dist/Feature';
import * as serverRenderingUtils from '../../../helpers/serverRenderingUtils';

export const OptimizelyExperiment = ({
  experiment,
  children,
}: {
  experiment: string;
  children: React.ReactNode | ChildrenRenderFunction;
}) =>
  !serverRenderingUtils.windowUndefined() && (
    <OExperiment experiment={experiment}>{children}</OExperiment>
  );

export const OptimizelyFeature = ({
  feature,
  children,
}: {
  feature: string;
  children: ChildrenRenderFunction;
}) =>
  !serverRenderingUtils.windowUndefined() && (
    <OFeature feature={feature}>{children}</OFeature>
  );
